import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Help Fill
 */

export default function HelpFillIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8.32653 10.1702H7.10204V10.1128C7.11735 8.29159 7.71429 7.73709 8.71429 7.16826C9.31122 6.82887 9.77551 6.28394 9.77551 5.5239C9.77551 4.587 9 3.99426 8.04082 3.99426C7.20408 3.99426 6.36225 4.45316 6.28571 5.58126H5C5.07653 3.95602 6.38775 3 8.04082 3C9.83673 3 11 4.08987 11 5.58126C11 6.63767 10.4694 7.37381 9.57143 7.88528C8.67347 8.41109 8.34694 8.92734 8.32653 10.1128V10.1702ZM8.67347 12.1396C8.67347 12.6128 8.2602 13 7.7551 13C7.25 13 6.83673 12.6128 6.83673 12.1396C6.83673 11.6663 7.25 11.2792 7.7551 11.2792C8.2602 11.2792 8.67347 11.6663 8.67347 12.1396Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
